import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { useLocalisation } from '@3plearning/lingui-cdn';
import { t } from '@lingui/macro';

import css from './course-empty-state.scss';

const CourseEmptyState = ({ onClickHandler }) => {
    const { i18n } = useLocalisation();
    const text = {
        headerText: i18n._(
            t(
                'Course Empty State - No skill quests assigned'
            )`No skill quests assigned`
        ),
        contentOneText: i18n._(
            t('Course Empty State - Please go to')`Please go to`
        ),
        contentTwoText: i18n._(
            t('Course Empty State - Skill Quests')`Skill Quests`
        ),
        contentThreeText: i18n._(
            t('Course Empty State - to start assigning')`to start assigning`
        )
    };

    return (
        <div className={css['course-empty-state']}>
            <h2 className={css.header}>{text.headerText}</h2>
            <div className={css.content}>
                <p>{text.contentOneText}</p>
                <button onClick={() => onClickHandler()}>
                    {text.contentTwoText}
                </button>
                <p>{text.contentThreeText}</p>
            </div>
        </div>
    );
};

CourseEmptyState.propTypes = {
    onClickHandler: PropTypes.func
};

export default styleable(css)(CourseEmptyState);



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/student/components/course-empty-state/course-empty-state.js